import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { monthlySubscription: { getMonthlySubscription, } } = apiUrls;

export const GET_MONTHLY_SUBSCRIPTION_SUCCESS = 'GET_MONTHLY_SUBSCRIPTION_SUCCESS';
export const GET_MONTHLY_SUBSCRIPTION_LOADING = 'GET_MONTHLY_SUBSCRIPTION_LOADING';


export const getMonthlySubscriptionData = ({ from: fromyear, to: toyear,
    fromMonth: frommonth, toMonth: tomonth }) => async (dispatch) => {
        try {
            const { url } = getMonthlySubscription
            const requestData = {
                ...getMonthlySubscription,
                url: url.replace('{{fromyear}}', fromyear).replace('{{toyear}}', toyear)
                // .replace('{{frommonth}}', frommonth).replace('{{tomonth}}', tomonth)
            };
            const data = await REQUEST(requestData);
            dispatch({
                type: GET_MONTHLY_SUBSCRIPTION_SUCCESS,
                data,
            })
        } catch (e) {

            dispatch({
                type: GET_MONTHLY_SUBSCRIPTION_SUCCESS,
                data: {
                    code: "",
                    modal: null,
                    notifications: null,
                    paginationInfo: null
                }
            })
        }

    }



export const handleLoader = isLoading => (dispatch) => {
    dispatch({
        type: GET_MONTHLY_SUBSCRIPTION_LOADING,
        isLoading
    })
}
